import * as React from "react";
import { IFtthOffer } from "@nju/data-access-portal-offers";
import { useDecodedToken } from "@nju/data-access-portal-wwt";
import { SelectedOffer } from "./SelectedOffer";

interface IOffersProps {
  setOffer: (offerId: string) => void;
  isLoading: boolean;
  selectedOffer: string | undefined;
  offers: IFtthOffer[];
  withBadge: boolean;
}

export function Offers({
  setOffer,
  isLoading,
  selectedOffer,
  offers,
  withBadge,
}: IOffersProps) {
  const installationToken = sessionStorage.getItem("installationToken");
  const decodedToken = useDecodedToken(installationToken);

  return (
    <>
      {offers.map((offer, index) => {
        return (
          <div className="w-full" key={`offer-${index}`}>
            <SelectedOffer
              filteredOffers={offers}
              isLoading={isLoading}
              isSfh={!!decodedToken?.address.isSfh}
              offer={offer}
              selectedOffer={selectedOffer}
              setOffer={setOffer}
              withBadge={withBadge}
            />
          </div>
        );
      })}
    </>
  );
}
